"use client";

import Link from "next/link";
import posthog from "posthog-js";

export interface UpsellModalProps {
  open: boolean;
  onClose: () => void;
  loggedIn: boolean;
  source: "trip" | "public";
}

export default function UpsellModal({ open, onClose, loggedIn, source }: UpsellModalProps) {
  if (!open) return null;
  return (
    <div className="car-modal-backdrop" onClick={onClose}>
      <div className="car-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="car-modal-title">Premium ★</h3>
        <p className="car-modal-text">
          Premium unlocks all designs and font pairings, and replaces the
          LiferRadar.com watermark with your own @handle.
        </p>
        {!loggedIn ? (
          <Link
            href="/login" className="car-generate-btn car-modal-cta"
            onClick={() => posthog.capture("carousel_upsell_clicked", { source, action: "login" })}
          >
            Sign up free →
          </Link>
        ) : (
          <p className="car-modal-text car-modal-soon">Premium is coming soon — stay tuned!</p>
        )}
        <button type="button" className="car-toggle-all" onClick={onClose}>
          Maybe later
        </button>
      </div>
    </div>
  );
}
